export const PROJECTS = [
    {
        title: "INCYT",
        description: "A web application that displays and provides insights on consolidated data and reports from IOT devices installed on farms and allows management and configuration of such devices.",
        technologies: {
            frontend: ["React", "Redux",  "TypeScript", "Material UI"],
            backend: ["Node.js", "Express.js", "PostgreSQL", "AWS"],
        }
    },
    {
        title: "MojoPay",
        description: "A payment facility system that offers merchant payments processing, chargeback management, and invoicing services.",
        technologies: {
            frontend: ["React", "Redux", "TypeScript", "Material UI", ],
            backend: ["Node.js", "Express.js", "MSSQL"],
        }
    },
    {
        title: "Data Extractor",
        description: "A web application that creates workers that  extracts data from several sources (CSV, databases, API), and maps and merges data into a single table in the database.",
           technologies: {
            frontend: ["JavaScript","React", "Material UI"],
            backend: ["Python", "Flask", "MySQL"],
        }
    },
    {
        title: "TrendSight",
        description: "A customer succcess platform that helps ensure clients achieve their anticipated outcomes for improved customer retention and satisfaction.",
           technologies: {
            frontend: ["React", "Material UI"],
            backend: ["Node.js", "Express.js", "MongoDB"],
        }
    }
];
